import Modal from './components/modal'

export default class Checkout {
    constructor(element) {
        this.checkout = element
        this.shippingCheckbox = this.checkout.querySelector('#ship-to-different-address-checkbox')
        this.shippingFields = this.checkout.querySelector('.checkout-shipping-fields')

        this.customerTypeRadioButtons = this.checkout.querySelectorAll('input[name=billing_customer_type]')
        this.companyFieldName = this.checkout.querySelector('#billing_company_field')
        this.companyFieldVATNumber = this.checkout.querySelector('#billing_company_vat_number')
        this.companyFieldEmail = this.checkout.querySelector('#billing_company_email_field')

        this.shippingMethodsField = this.checkout.querySelector('.cart-shipping-methods')

        if (this.shippingMethodsField) {
            this.shippingMethodSecurity = this.checkout.querySelector('.checkout-data-security').value;
            this.shippingMethods = this.shippingMethodsField.getElementsByTagName('input')
            this.cartOverview = this.checkout.querySelector('.checkout-cart-overview')


            for (let i = 0; i < this.shippingMethods.length; i++) {
                this.shippingMethods[i].addEventListener('click', (e) => {
                    this.handleShippingMethodsClick(this.shippingMethods[i])
                })
            }

            // Shipping address checkbox is checked
            this.shippingCheckbox.addEventListener('change', () => this.handleShippingCheckboxChange())
        }


        //this.couponModalButton = this.checkout.querySelector('.button-modal-coupon')

        //this.couponModalElement = this.checkout.querySelector('#modal-coupon')



        // Customer type changes
        for (let radioButton of this.customerTypeRadioButtons) {
            radioButton.addEventListener('change', () => this.handleCustomerTypeChange())
        }

        // Init customer type
        this.initCustomerType()

        // Modal for coupon code
        //this.couponModalButton.addEventListener('click', () => this.openCouponModal())
        //this.couponModal = new Modal(this.couponModalElement)

        // Modal for login
        this.loginModalButton = this.checkout.querySelector('.button-modal-login')
        this.loginModalElement = this.checkout.querySelector('#modal-login')

        if (this.loginModalButton) {
            this.loginModalButton.addEventListener('click', () => this.openLoginModal())
            this.loginModal = new Modal(this.loginModalElement)
        }
    }

    handleShippingMethodsClick(element) {
        const shippingMethodName = element.getAttribute('name')
        const shippingMethodValue = element.value
        const url = "?wc-ajax=update_order_review"
        const request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                const response = JSON.parse(request.response)
                const updatedCartOverviewInnerHTML = response.fragments['.woocommerce-checkout-review-order-table']
                this.cartOverview.innerHTML = updatedCartOverviewInnerHTML
            } else {

            }
        };

        request.onerror = function () {
            // There was a connection error of some sort
        };

        request.send(`${shippingMethodName}=${shippingMethodValue}&security=${this.shippingMethodSecurity}`)
    }

    handleShippingCheckboxChange() {
        const useShippingAddress = this.shippingCheckbox.checked
        if(useShippingAddress) {
            this.showShippingFields()
        } else {
            this.hideShippingFields()
        }
    }
    
    showShippingFields() {
        this.shippingFields.classList.remove('hidden')
    }

    hideShippingFields() {
        this.shippingFields.classList.add('hidden')
    }

    handleCustomerTypeChange() {
        let checked_value = this.checkout.querySelector('input[name=billing_customer_type]:checked').value

        if (checked_value === "private") {
            this.companyFieldName.style.display = "none"
            this.companyFieldVATNumber.style.display = "none"
            this.companyFieldEmail.style.display = "none"
        }
        else {
            this.companyFieldName.style.display = "block"
            this.companyFieldVATNumber.style.display = "block"
            this.companyFieldEmail.style.display = "block"
        }
    }

    initCustomerType() {
        this.handleCustomerTypeChange()
    }

    /*openCouponModal() {
        this.couponModal.open()
    }*/

    openLoginModal() {
        this.loginModal.open()
    }
}